'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

//EwSiteApp.requires.push('ngMessages');
//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

//function modalRejectHandler(result){
//	console.log(result);
//}

EwSiteApp.controller('formSubmitCtrl', ['$scope', '$filter', '$log', '$uibModal', 'ajaxSearch', function($scope, $filter, $log, $uibModal, ajaxSearch){
	$scope.form_id = "";
	$scope.uploads_count = 0;
	$scope.total_upl = 0;
	$scope.uploaded_file = false;
	$scope.form;
	$scope.submitted = false;
	$scope.requiredFields = [];
	$scope.bad_address_length = 5;
	$scope.addresses_1 = [];
	$scope.findUrl = jsForms.findUrl;
	$scope.formSubmit = function(e){
		e.preventDefault();
		$scope.submitted = true;
		let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
					if (document.getElementById('g-recaptcha-response-hidden')) {
						$('#g-recaptcha-response-hidden').val(token);
					} else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						$scope.form[0].appendChild(inp);
					}
					$scope.form[0].submit();
				});
			});
		} else {
			$scope.form[0].submit();
		}
	};
	$scope.changeState = function(field_id, state){
		if(typeof($scope.requiredFields['field_'+field_id])!=='undefined'){
			$scope.requiredFields['field_'+field_id].valid = state;
		}
	};

	$scope.addRequired = function(field_id){
		if(typeof($scope.requiredFields['field_'+field_id])==='undefined'){
			$scope.requiredFields['field_'+field_id] = {
				id:field_id,
				valid:false
			};
		}
		if(arguments[1] && typeof(arguments[1]) !== 'undefined'){
			$scope.requiredFields['field_'+field_id].parent_field_id = arguments[1];
		}
	};

	$scope.clearRequiredByChoiseId = function(parent_field_id){
		let toRemove = [];
		for(let field in $scope.requiredFields){
			if(typeof($scope.requiredFields[field].parent_field_id) !== 'undefined'){
				if(parseInt($scope.requiredFields[field].parent_field_id)==parseInt(parent_field_id)){
					toRemove[field] = $scope.requiredFields[field];
				}
			}
		}
		
		for(let rmField in toRemove){
			delete $scope.requiredFields[rmField];
		}
	};

	$scope.requiredFieldsValid = function(){
		for(let file in $scope.requiredFields){
			if(!$scope.requiredFields[file].valid){
				return false;
			}
		}
		return true;
	};

	$scope.termsModal = function () {
		var template = 'forms/modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'formsPreviewCtrl',
			//size: 'sm',
			resolve: {
				item: function () {
					return $scope.rulesText;
				}
			}
		});

//		modalInstance.result.then(function(result){
//			
//		}, modalRejectHandler);
	};

	$scope.getArrayField = function (form,name,field_id) {
		return form[name+'['+field_id+']'];
	};

$scope.applyMessages = function (form, name) {
  return form[name] && form[name].$dirty && form[name].$invalid;
};

$scope.getArrayField = function (form, name) {
  return form[name];
};
	
}]).directive('formSubmit', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
			
			scope.rulesText = '';

			if (attr.rulesText && attr.rulesText !== '') {
				scope.rulesText = unescape(attr.rulesText);
			}
		}
	};
});

EwSiteApp.controller('formsPreviewCtrl', ['$scope', '$uibModalInstance', '$sce', 'item', function ($scope, $uibModalInstance, $sce, item) {
	$scope.rulesText = $sce.trustAsHtml(angular.copy(item));
	
	$scope.save = function () {
		$uibModalInstance.close($scope.rulesText);
	};
	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};
}]);

EwSiteApp.controller('checkboxCtrl', ['$scope', '$timeout', '$filter', function($scope, $timeout, $filter){
	$scope.fieldId = 0;
	$scope.choise_id = [];

	$scope.initController = function(fieldId){
		$scope.fieldId = fieldId;
		$scope.$parent.addRequired($scope.fieldId);
		$timeout(function(){
			$scope.choiseChanged();
		},50);
	};

	$scope.choiseChanged = function(){
		let filter = $filter('filter')($scope.choise_id, true, true);
		if(filter.length>0){
			$scope.$parent.changeState($scope.fieldId, true);
		}
		else{
			$scope.$parent.changeState($scope.fieldId, false);
		}
	};

}]);

EwSiteApp.controller('radioCtrl', ['$scope', '$timeout', function($scope, $timeout){
	$scope.fieldId = 0;
	$scope.choise_id;

	$scope.initController = function(fieldId){
		$scope.fieldId = fieldId;
		$scope.$parent.addRequired($scope.fieldId);
		$timeout(function(){
			$scope.choiseChanged();
		},50);
	};
	
	$scope.choiseChanged = function(){
		if($scope.choise_id){
			$scope.$parent.changeState($scope.fieldId, true);
		}
		else{
			$scope.$parent.changeState($scope.fieldId, false);
		}
	};

}]);

EwSiteApp.controller('dependentFieldCtrl', ['$scope', '$timeout', function($scope, $timeout){
	$scope.fieldId = 0;
	$scope.choise_id;
	$scope.dependent_fields = {};

	$scope.initController = function(fieldId){
		
		$scope.fieldId = fieldId;
		$scope.$parent.addRequired($scope.fieldId);
		$timeout(function(){
			$scope.choiseChanged();
		},50);
	};

$scope.choiseChanged = function(){
    // Clear child select2 fields without resetting the parent
    $timeout(function() {
        // Target only the child select2 fields within the dependant-wrapper
        $('.dependant-wrapper select').each(function(){
            $(this).val(null).trigger('change');  // Reset each child select2 field
        });
    }, 0);

    // Proceed with your logic to handle required fields and choices
    if (typeof($scope.choise_id) !== 'undefined' && typeof($scope.choise_id[$scope.fieldId]) !== 'undefined') {
        $scope.$parent.clearRequiredByChoiseId($scope.fieldId);
        
        // Handle dependent fields logic
        for (let dep_field of $scope.dependent_fields['c' + $scope.choise_id[$scope.fieldId]]) {
            dep_field.required = !!(dep_field.required == 1 || dep_field.required === true);
            if (dep_field.required) {
                $scope.$parent.addRequired(parseInt(dep_field.id), $scope.fieldId);
            }
        }
    }

    // Change the state of the parent field based on whether it has a selected value
    if ($scope.choise_id) {
        $scope.$parent.changeState($scope.fieldId, true);
    } else {
        $scope.$parent.changeState($scope.fieldId, false);
    }
};

	

}]);

EwSiteApp.controller('elasticSearchCtrl', ['$scope', '$timeout', '$log', 'ajaxSearch', function($scope, $timeout, $log, ajaxSearch){
	$scope.fieldId = 0;
	$scope.choise_id;
	$scope.uvis_address_id = null;
	$scope.findUrl = $scope.$parent.findUrl;
	$scope.uvis_address_required = false;
	$scope.show_bad_searches = false;
	$scope.noAddressFound = false;
	$scope.value_text = {};

	$scope.initController = function(fieldId, required){
		$scope.fieldId = fieldId;
		$scope.uvis_address_required = required;
		if(required){
			$scope.$parent.addRequired($scope.fieldId);
			$timeout(function(){
				$scope.addressChanged();
			},50);
		}
	};

	$scope.getFieldModel = function () {
		return $scope.value_text[$scope.fieldId];
	};

	$scope.findAddress = function () {
		$scope.uvis_address_id = null;
		$scope.addressChanged();
		if ($scope.findUrl !== '' && $scope.value_text[$scope.fieldId] != '') {
			$scope.loading = true;
			$scope.show_bad_searches = false;
			$scope.clearAddressSugggests();
			ajaxSearch.search($scope.findUrl, {address: $scope.value_text[$scope.fieldId]}).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
						$scope.noAddressFound = false;
						$scope.show_bad_searches = false;
					} else {
						$scope.addresses = [];
						$scope.messages = response.messages;
						$scope.noAddressFound = true;
						$scope.showSuggest = false;

						/*$scope.number_bad_searches += 1;
						 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
						 $scope.show_bad_searches = true;
						 }*/
						if ($scope.value_text[$scope.fieldId] !== '' && $scope.value_text[$scope.fieldId].length >= $scope.$parent.bad_address_length) {
//							console.log($scope.value_text[$scope.fieldId].length, $scope.$parent.bad_address_length)
							$scope.show_bad_searches = true;
						}
					}
					$scope.loading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
		}
	};

	$scope.setAddress = function (address) {
		$scope.uvis_address_id = address._source.adr_id;
		$scope.value_text[$scope.fieldId] = address._source.adr_sudetinis_adresas;
		$scope.addressChanged();
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
		$scope.messages = [];
	};

	$scope.addressChanged = function(){
		if($scope.uvis_address_required && ($scope.value_text[$scope.fieldId] === 'undefined' || $scope.value_text[$scope.fieldId] === '')){
			$scope.$parent.changeState($scope.fieldId, false);
			return;
		}

		if($scope.value_text[$scope.fieldId] && $scope.value_text[$scope.fieldId] !== ''){
			$scope.$parent.changeState($scope.fieldId, true);
		}

	};
}]);

